export default "__VITE_ASSET__CwBGAm7y__"